export default __webpack_public_path__ + "static/media/PDP_EFM_Bottle.579acd11.jpg";